export const ProjectData = [
    {
        id:1,
        title:"Music Player",
        about:"A simple music player integrated with a library to jump to other awesome songs. Fully responsive. My first React Project.",
        tags: ["ReactJS","SCSS"],
        demo: "https://wxld.github.io/MusicPlayer/",
        github: "https://github.com/Wxld/MusicPlayer",
        image: require("../../assets/projects/Musicplayer.png").default,
    },
    {
        id:2,
        title:"Colorly",
        about:"A color picker to Devs pick colors of their choice, generate random ones and save them by making palletes of five.",
        tags: ["Javascript","HTML","CSS"],
        demo: "https://wxld.github.io/Colorly/",
        github: "https://github.com/Wxld/Colorly",
        image: require("../../assets/projects/Colorly.png").default,
    },
];